import React, { Children } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../checkbox';

class ParentCheckbox extends React.Component {
  onChildChange(parentCheckboxValue, childValue) {
    if (parentCheckboxValue === childValue || !childValue) {
      // They clicked this checkbox
      this.props.onChange(parentCheckboxValue);
    } else {
      this.props.onChange(parentCheckboxValue, childValue);
    }
  }

  render() {
    return (
      <div className="uni-form__check-group--parent">
        <Checkbox {...this.props} onChange={() => this.props.onChange()} />
        <div className="uni-form__check-group--children">
          {Children.map(this.props.children, child => {
            const Component = child.type;
            const { props: childProps } = child;
            const checked = this.props.childValues && this.props.childValues.getIn([childProps.value, 'checked']);
            const childValues = this.props.childValues && this.props.childValues.getIn([childProps.value, 'children']);
            const partiallyChecked =
              this.props.childValues && this.props.childValues.getIn([childProps.value, 'partial']);
            const overrideProps = {
              onChange: this.onChildChange.bind(this, childProps.value),
              checked,
              childValues,
              nested: this.props.nested,
              partiallyChecked,
            };
            const newProps = Object.assign({}, childProps, overrideProps);
            if (this.props.disabled) {
              newProps.disabled = this.props.disabled;
            }
            return <Component {...newProps} />;
          })}
        </div>
      </div>
    );
  }
}

ParentCheckbox.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  id: PropTypes.string,
  checked: PropTypes.bool,
  childValues: PropTypes.object,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  nested: PropTypes.bool,
};

ParentCheckbox.defaultProps = {
  checked: false,
  disabled: false,
  onChange: () => {},
  nested: false,
};

export default ParentCheckbox;



// WEBPACK FOOTER //
// ./src/forms/parent-checkbox/index.jsx